import { RecordDataSource } from "../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsServiceName as ColumnDefinitionSetServiceName,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../records/views/recordGridView";
import { vsObjectName as permissionObjectName } from "./permissions";

import { vsObjectName as roleObjectName } from "./roles";
import { vsObjectName as userObjectName } from "./user";

export const vsObjectName = "userRolePermission";

export const vsRolePermissionColumns = `${vsObjectName}.rolePermissions`;

userRolePermissionObjectConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function userRolePermissionObjectConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  configureGrid(
    recordGridViewServiceProvider,
    columnDefinitionSetServiceProvider
  );
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsRolePermissionColumns,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) => [
        ...columnDefinitionSetService.getColumnDefinitionSet(roleObjectName),
        ...columnDefinitionSetService.getColumnDefinitionSet(
          permissionObjectName
        ),
      ],
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    ColumnDefinitionServiceName,
    (
      columnDefinitionSetService: ColumnDefinitionSetService,
      columnDefinitionService: ColumnDefinitionService
    ) => [
      columnDefinitionService.getLinkColDef({
        headerName: "Info",
        iconClass: "fa fa-info-circle text-primary",
        colId: "info",
        requiresPermission: "userModify",
        width: 20,
        stateExpression:
          "main.users.detail.userPermissions({userId: data.UserAuthId})",
      }),
      ...columnDefinitionSetService.getColumnDefinitionSet(userObjectName),
      ...columnDefinitionSetService.getColumnDefinitionSet(roleObjectName),
      ...columnDefinitionSetService.getColumnDefinitionSet(
        permissionObjectName
      ),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsRolePermissionColumns, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return getGridConfiguration(
        serverUtility,
        gridSettingsService,
        vsRolePermissionColumns
      );
    },
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return getGridConfiguration(
        serverUtility,
        gridSettingsService,
        vsObjectName
      );
    },
  ]);
}

function getGridConfiguration(
  serverUtility: ServerUtility,
  gridSettingsService: GridSettingsService,
  objectName: string
) {
  return {
    columnDefinitionSet: objectName,
    defaultSort: "UserName,RoleName,PermissionName",
    gridDataSource: new RecordDataSource(
      serverUtility,
      "/api/user/rolePermissions"
    ),
    gridSettings: gridSettingsService.getGridSettings(Symbol(objectName)),
    nameSingular: "User Permission",
    namePlural: "User Permissions",
  };
}
